import { gql } from './apollo';

export const GET_ACCOUNT_BY_NAME_ADDRESS = gql`
    query ($name: MultiTypeInput!, $address: MultiTypeInput!) {
        table(
            name: "account"
            filter: [
                { left: "name", right: $name, expression: "iLIKE" }
                { left: "address_line_1__c", right: $address, expression: "iLIKE" }
                { left: "sfid", right: "null", expression: "!=" }
            ]
            limit: 1
        )
    }
`;

export const GET_ACCOUNT_BY_NAME = gql`
    query ($account_name: MultiTypeInput!) {
        table(
            name: "account"
            filter: [
                { table: "account", left: "name", right: $account_name, expression: "iLIKE" }
                { left: "sfid", right: "null", expression: "!=" }
            ]
            limit: 1
        )
    }
`;

export const GET_ACCOUNTS_FILTER_BY_NAME_AND_ADDRESS = gql`
    query ($like: MultiTypeInput = "%", $not_like: MultiTypeInput, $limit: Int = 50) {
        table(
            name: "account"
            filter: [
                {
                    or_: [
                        { table: "account", left: "name", right: $like, expression: "iLIKE" }
                        {
                            table: "account"
                            left: "address_line_1__c"
                            right: $like
                            expression: "iLIKE"
                        }
                    ]
                }
                { table: "account", left: "name", right: $not_like, expression: "NOT iLIKE" }
                { left: "sfid", right: "null", expression: "!=" }
                { left: "isdeleted", right: "false", expression: "=" }
            ]
            orderBy: "name"
            limit: $limit
        )
    }
`;

export const GET_ACCOUNTS_FILTER_BY_CONTACT_NAME_EMAIL_PHONE = gql`
    query ($like: MultiTypeInput = "%", $not_like: MultiTypeInput!, $limit: Int = 10) {
        table(
            name: "account"
            join: [{ table: "contact", fk: "accountid", joinFk: "sfid" }]
            filter: [
                {
                    or_: [
                        { table: "contact", left: "name", right: $like, expression: "iLIKE" }
                        { table: "contact", left: "email", right: $like, expression: "iLIKE" }
                        { table: "contact", left: "phone", right: $like, expression: "iLIKE" }
                    ]
                }
                { table: "account", left: "name", right: $not_like, expression: "NOT iLIKE" }
                { left: "sfid", right: "null", expression: "!=" }
                { left: "isdeleted", right: "false", expression: "=" }
            ]
            contain: [
                {
                    table: "contact"
                    fk: "accountid"
                    joinFk: "sfid"
                    joinTable: "account"
                    where: [
                        {
                            or_: [
                                {
                                    table: "contact"
                                    left: "name"
                                    right: $like
                                    expression: "iLIKE"
                                }
                                {
                                    table: "contact"
                                    left: "email"
                                    right: $like
                                    expression: "iLIKE"
                                }
                                {
                                    table: "contact"
                                    left: "phone"
                                    right: $like
                                    expression: "iLIKE"
                                }
                            ]
                        }
                    ]
                }
            ]
            orderBy: "name"
            limit: $limit
        )
    }
`;

export const GET_ACCOUNT_BY_ORDER = gql`
    query ($like: MultiTypeInput = "%", $not_like: MultiTypeInput, $limit: Int = 10) {
        table(
            name: "account"
            join: [{ table: "order", fk: "accountid", joinFk: "sfid" }]
            filter: [
                { left: "name", right: $not_like, expression: "NOT iLIKE" }
                { left: "sfid", right: "null", expression: "!=" }
                { left: "isdeleted", right: "false", expression: "=" }
                { table: "order", left: "status", right: "Activated", expression: "=" }
                {
                    or_: [
                        { table: "order", left: "vts_id", right: $like, expression: "iLIKE" }
                        {
                            and_: [
                                { table: "order", left: "ecomm", right: "true", expression: "=" }
                                {
                                    table: "order"
                                    left: "external_id__c"
                                    right: $like
                                    expression: "iLIKE"
                                }
                            ]
                        }
                    ]
                }
            ]
            contain: [
                {
                    table: "order"
                    fk: "accountid"
                    joinFk: "sfid"
                    joinTable: "account"
                    columns: ["external_id__c", "vts_id", "contact__c"]
                    limit: 1
                    where: [
                        {
                            or_: [
                                {
                                    table: "order"
                                    left: "vts_id"
                                    right: $like
                                    expression: "iLIKE"
                                }
                                {
                                    and_: [
                                        {
                                            table: "order"
                                            left: "ecomm"
                                            right: "true"
                                            expression: "="
                                        }
                                        {
                                            table: "order"
                                            left: "external_id__c"
                                            right: $like
                                            expression: "iLIKE"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
                { table: "contact", fk: "accountid", joinFk: "sfid", joinTable: "account" }
            ]
            orderBy: "name"
            limit: $limit
        )
    }
`;

export const CREATE_ACCOUNT = gql`
    mutation (
        $name: MultiTypeInput!
        $address_line_1__c: MultiTypeInput!
        $billingstreet: MultiTypeInput!
        $billingcity: MultiTypeInput!
        $billingstate: MultiTypeInput!
        $billingpostalcode: MultiTypeInput!
        $billingcountry: MultiTypeInput!
        $external_id__c: MultiTypeInput!
        $sfid: MultiTypeInput!
        $createddate: MultiTypeInput!
    ) {
        createRow(
            table: "account"
            values: [
                { property: "name", value: $name }
                { property: "address_line_1__c", value: $address_line_1__c }
                { property: "billingstreet", value: $billingstreet }
                { property: "billingcity", value: $billingcity }
                { property: "billingstate", value: $billingstate }
                { property: "billingpostalcode", value: $billingpostalcode }
                { property: "billingcountry", value: $billingcountry }
                { property: "external_id__c", value: $external_id__c }
                { property: "createddate", value: $createddate }
                { property: "sfid", value: $sfid }
                { property: "isdeleted", value: false }
            ]
        )
    }
`;

export const UPDATE_ACCOUNT = gql`
    mutation (
        $id: String!
        $name: MultiTypeInput!
        $address_line_1__c: MultiTypeInput!
        $billingstreet: MultiTypeInput!
        $billingcity: MultiTypeInput!
        $billingstate: MultiTypeInput!
        $billingpostalcode: MultiTypeInput!
        $billingcountry: MultiTypeInput!
        $external_id__c: MultiTypeInput!
    ) {
        updateRow(
            table: "account"
            id: $id
            values: [
                { property: "name", value: $name }
                { property: "address_line_1__c", value: $address_line_1__c }
                { property: "billingstreet", value: $billingstreet }
                { property: "billingcity", value: $billingcity }
                { property: "billingstate", value: $billingstate }
                { property: "billingpostalcode", value: $billingpostalcode }
                { property: "billingcountry", value: $billingcountry }
                { property: "external_id__c", value: $external_id__c }
                { property: "isdeleted", value: false }
            ]
        )
    }
`;
